// extracted by mini-css-extract-plugin
export default {"blogs":"blogs_blogs__QjypB","blogs_list":"blogs_blogs_list__l3G3b"};